import React from 'react';
import PropTypes from 'prop-types';

/**
 * Classic Badge
 * @param {Object} props
 * @param {string} props.title - The title of the badge
 * @returns {JSX.Element}
 */
export default function ClassicBadge({ title = 'Classic — Enkel Rondje' }) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" aria-label={title} role="img">
      <rect width="20" height="20" rx="10" fill="#4cb5f5" />
      {/* Zwembril */ }
      <path d="M5.5 6.5c0 1 1 1.5 2 1.5s2-.5 2-1.5h-4z" fill="white" />
      <path d="M10.5 6.5c0 1 1 1.5 2 1.5s2-.5 2-1.5h-4z" fill="white" />
      <path d="M5.5 6.5c0-1 2-2 4.5-2s4.5 1 4.5 2" stroke="white" strokeWidth="1" fill="none" />
      {/* Hardloopschoen */ }
      <path d="M5.5 13c0-.5.5-1 1-1h4l1.5 1.5c.3.3.3.5.3.5h-6.5c-.2 0-.3-.3-.3-.5z" fill="white" />
      <path d="M7 12l.5.5m1-.5l.5.5" stroke="#4cb5f5" strokeWidth="0.5" />
    </svg>
  );
}

ClassicBadge.propTypes = {
  title: PropTypes.string,
};
